import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataServiceService } from '../services/data-service.service';
import { ToolbarComponent } from '../dispatch/toolbar/toolbar.component';
import { ThemeServiceService } from '../services/theme-service.service';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { TabStateService } from '../services/tab-state.service';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  private themeSubscription: Subscription = new Subscription();
  isProduction = environment.production;


  constructor(
    private router: Router,
    private themeservice: ThemeServiceService,
    private tabStateService: TabStateService
  ) {
    this.checked = this.themeservice.getTheme() === 'viva-dark';
  }

  @ViewChild('toolbar') toolbarComponent!: ToolbarComponent;
  dataServiceService: DataServiceService = inject(DataServiceService)
  authService: AuthService = inject(AuthService)

  selectedDate: Date = new Date()

  checked = false

  menuItems = [
    {
      label: 'Schedule',
      icon: 'pi pi-calendar',
      command: () => this.tabStateService.setActiveTab('schedule')
    },
    {
      label: 'Notes',
      icon: 'pi pi-pencil',
      command: () => this.tabStateService.setActiveTab('notes')
    }
  ];

  activeItem = this.menuItems[0];

  userDisplayName: string = '';
  userRole: string = '';

  ngOnInit() {
    const formatted_date = DateTime.fromJSDate(this.selectedDate)
      .setZone('America/Chicago')
      .toFormat('yyyy-MM-dd');
    this.dataServiceService.updateDate(formatted_date);

    // Subscribe to theme changes
    this.themeSubscription = this.themeservice.theme$.subscribe(theme => {
      this.checked = theme === 'viva-dark';
    });

    this.authService.userProfile$.subscribe((profile) => {
      this.userDisplayName = profile?.name;
      this.userRole = profile?.roles?.[0];
      console.log(profile);
    });
    
  }

  ngOnDestroy() {
    // Clean up subscription
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  changeTheme(theme: string) {
    this.themeservice.setTheme(theme);
  }

  onDateSelect() {
    const formattedDate = DateTime.fromJSDate(this.selectedDate)
      .setZone('America/Chicago')
      .toFormat('yyyy-MM-dd');

    this.dataServiceService.updateDate(formattedDate);
  }

  // Date navigation methods
  previousDay() {
    const prevDate = DateTime.fromJSDate(this.selectedDate)
      .setZone('America/Chicago')
      .minus({ days: 1 })
      .toJSDate();

    this.selectedDate = prevDate;
    this.onDateSelect();
  }

  nextDay() {
    const nextDate = DateTime.fromJSDate(this.selectedDate)
      .setZone('America/Chicago')
      .plus({ days: 1 })
      .toJSDate();

    this.selectedDate = nextDate;
    this.onDateSelect();
  }

  toCentralTime(date: Date): Date {
    return DateTime.fromJSDate(date)
      .setZone('America/Chicago')
      .startOf('day')
      .toJSDate();
  }


  isDispatchDashboard(): boolean {
    return this.router.url === '/dispatch_dash';
  }

  toggleTheme() {
    this.checked = !this.checked;
    this.changeTheme(this.checked ? 'viva-dark' : 'viva-light');
  }

  isDriverSchedule(): boolean {
    return this.router.url.includes('/driver-schedule');
  }

}
